import React, { Fragment, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import { LoadingComponent } from 'recupero-comunes'



import {
  configuracionFormAction18, obtenerComboCambiarAmbitoGestion, obtenerComboTipoGestion, obtenerDatosGestion

} from '../../store/actions/trazabilidad-hitos-action'

import GrillaBusqueda from './grillaBusqueda'
import SeguimientosHitos from './SeguimientosHitos'



// import Historial from './historial'
const TrazabilidadHitosModal = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso  }) => {
  const [loading, setLoading]=useState(false)
  const [listaGrilla, setListaGrilla] = useState(null)
  const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves} = data_recepciona
  const data_proceso_extrajudicial = useSelector(
    (state) => state.procesoExtrajudicialReducer
  )
  const { datosGestionImplicado } = data_proceso_extrajudicial

  const dispatch = useDispatch()
  useEffect(() => {     

    dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
  
  }, [dispatch])
  useEffect(() => {
    if(llaves){
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({ rutcia: llaves && llaves['idOrgCaso'], idform: 18 })
      ).toString('base64')
      dispatch(configuracionFormAction18(query))
      
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({concepto: 232})
        ).toString('base64')
        dispatch(obtenerComboCambiarAmbitoGestion(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({idCaso:llaves && llaves["idCaso"], idImplicado: llaves && llaves["idImplicado"]})
        ).toString('base64')
        dispatch(obtenerDatosGestion(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({concepto: 207})
        ).toString('base64')
        dispatch(obtenerComboTipoGestion(query))
      })
      .then(()=>{
        setLoading(false)
      })
    }
  }, [dispatch,llaves])
  
  
  return (
    <>
       <LoadingComponent show={loading} />
        <SeguimientosHitos setListaGrilla={setListaGrilla} handleClose={handleClose} />
      
        <GrillaBusqueda listaGrilla={listaGrilla}  setListaGrilla={setListaGrilla}/>
        
     
    </>
  )
}

export default TrazabilidadHitosModal
